import {
  HealthSystemDALEnumsLocationStableType,
  HealthSystemDomainUsersResultUserViewModel,
  SystemDayOfWeek
} from '../api/HealthSystemApi';
import { PageableResult } from './common';
import { FarmType } from './farm';

export interface UserViewModel {
  id: string;
  name: string;
  role: string;
  email: string;
  languageIso: string;
  farmId: string;
}

/**
 * A user as offered by `UserSelect`'s pick list. Trimmed to `id` and `name`, the only fields the
 * select reads; `name` mirrors the API's nullable field instead of repeating `UserViewModel`'s
 * (untrue) non-null claim.
 */
export interface UserOption {
  id: string;
  name: string | null;
}

export const toUserOption = (dto: HealthSystemDomainUsersResultUserViewModel): UserOption => ({
  id: dto.id,
  name: dto.name ?? null
});

export interface UserActionLog {
  id: string;
  type: UserActionLogType;
  dateTime: Date;
  data: string | null;
  number: string;
  macAddress: string;
}

export interface UserActionLogResult extends PageableResult<UserActionLog> {}

export enum UserActionLogType {
  Any = 0,

  Injections = 100,

  Animals = 200,
  AnimalsDied = 201,
  AnimalsByInjection = 202,

  Locations = 300,
  AnimalsDiedByLocation = 301,
  AnimalsSickByLocation = 302,

  DeviceFirmwareUpdate = 500
}

export interface UserAuthResult {
  farmId: string;
  userId: string;
  token: string;
  refreshToken: string;
  farmType: FarmType;
}

export interface AuthVeterinaryResult {
  contactId: string;
  veterinaryId: string;
  token: string;
  refreshToken: string;
}

export interface UserQueryResult extends PageableResult<UserViewModel> {}

export interface CreateUpdateUserViewModel {
  id: string;
  farmId: string;
  email: string;
  name: string;
  password: string;
  role: string;
  languageIso: string;
  availability: SystemDayOfWeek[];
  stables: HealthSystemDALEnumsLocationStableType[];
  isActivated: boolean;
  isDeactivated: boolean;
}

export interface FarmContactViewModel {
  name: string;
  email: string;
  phone: string;
  info: string;
  isPrimary: boolean;
  type: FarmSettingsContactType;
}

export enum FarmSettingsContactType {
  Doctor = 100,
  Manager = 200,
  Supplier = 300
}
